<template>
  <div>
    <a-button type="primary" @click="goback">返回</a-button>
    <span>菜单名称</span> <a-input v-model="name" />
    <span>上级菜单</span>
    <a-select
      :default-value="provinceData[0].name"
      style="width: 120px"
      @change="handleProvinceChange"
    >
      <a-select-option v-for="province in provinceData" :key="province.objId">
        {{ province.name }}
      </a-select-option>
    </a-select>
    <span>是否为商家路由</span>
    <a-radio-group v-model="value">
      <a-radio-button value="1">是的</a-radio-button>
      <a-radio-button value="0">不是</a-radio-button>
    </a-radio-group>
    <span>菜单路径</span> <a-input v-model="path" /> <span>前端图标</span>
    <a-input v-model="icon" />
    <span>compoent</span>
    <a-input v-model="component" /> <span>排序</span>
    <a-input v-model="sort" />
    <a-button type="primary" @click="addmMenuData">提交</a-button>
    <a-button>重置</a-button>
  </div>
</template>
<script>
import { addMenu, getMenu } from "@/api/testApi.js";
export default {
  data() {
    return {
      provinceData: [],
      component: "",
      parentId: 0,
      value: 1,
      name: "",
      path: "",
      icon: "",
      sort: 0,
    };
  },
  created() {
    this.getMenuDetails();
  },
  methods: {
    goback() {
      this.$router.push("/home/right1");
    },
    handleProvinceChange(value) {
      console.log(value, "value");
      this.parentId = value;
    },
    addmMenuData() {
      console.log(this.value);
      addMenu({
        component: this.component,
        icon: this.icon,
        name: this.name,
        parentId: this.parentId,
        path: this.path,
        shop: this.value,
        sort: this.sort,
      }).then((res) => {
        console.log(res);
      });
    },
    getMenuDetails() {
      getMenu().then((res) => {
        console.log(res.data, "data");
        this.provinceData = res.data;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/right/right2.vue